import { render, staticRenderFns } from "./query-tab.vue?vue&type=template&id=15214346"
import script from "./query-tab.vue?vue&type=script&setup=true&lang=js"
export * from "./query-tab.vue?vue&type=script&setup=true&lang=js"
import style0 from "./query-tab.vue?vue&type=style&index=0&id=15214346&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/.pnpm/vue-loader@15.11.1_qhqm3mauky62uixplfzayyuc5e/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports